"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = extend;

var _matchAndCrop = _interopRequireDefault(require("./transform/matchAndCrop"));

var _min = _interopRequireDefault(require("./compute/min"));

var _max = _interopRequireDefault(require("./compute/max"));

var _median = _interopRequireDefault(require("./compute/median"));

var _histogram = _interopRequireDefault(require("./compute/histogram"));

var _histograms = _interopRequireDefault(require("./compute/histograms"));

var _average = _interopRequireDefault(require("./utility/average"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable import/order */
function extend(Stack) {
  // let inPlace = {inPlace: true};
  Stack.extendMethod('matchAndCrop', _matchAndCrop.default);
  Stack.extendMethod('getMin', _min.default);
  Stack.extendMethod('getMax', _max.default);
  Stack.extendMethod('getMedian', _median.default);
  Stack.extendMethod('getHistogram', _histogram.default);
  Stack.extendMethod('getHistograms', _histograms.default);
  Stack.extendMethod('getAverage', _average.default);
}